import React from 'react';
import AddExistingOrphanFundSummary from './AddExistingOrphanFundSummary';
import { withStyles } from '@material-ui/core/styles';
import { FormSpy } from 'react-final-form';
import CustomSimpleForm from '../../../core/components/form/CustomSimpleForm';

const styles = () => ({
  fullWidth: {
    width: '100%'
  },
  form: {
    '& > div': {
      paddingTop: '0px !important',
      paddingBottom: '0px !important'
    }
  }
});

const AddExistingOrphanFundForm = props => {
  const { handleSubmit, setFundFormProps, fundId, classes } = props;
  return (
    <CustomSimpleForm
      initialValues={{ funds: [], fundId }}
      toolbar={null}
      // We override the redux-form name to avoid collision with the react-admin main form
      resource="funds"
      // We override the redux-form onSubmit prop to handle the submission ourselves
      save={handleSubmit}
      className={classes.form}
      variant="standard"
      margin="normal"
    >
      <FormSpy>
        {props => {
          setFundFormProps(props);
          return <AddExistingOrphanFundSummary {...props} fundId={fundId} />;
        }}
      </FormSpy>
    </CustomSimpleForm>
  );
};

export default withStyles(styles)(AddExistingOrphanFundForm);
